import React, { useState, FormEvent, useRef, useEffect } from 'react';
import { encode } from 'base-64';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import {
  Container,
  Modal,
  InputBlock,
  FormLabel,
  InputLogin,
  ButtonLogin,
  MainLogo,
  ContainerForget,
  LinkForgotPass,
  FormContainer,
  InputCode,
  CodeContainer,
  ResendCodeText,
  ResendCodeLink,
  MessageInfo
} from './styles';

import logoEthosx from '../../assets/images/logo.png';
import { FaChevronLeft } from 'react-icons/fa';
import { styleSheet } from '../../assets/styles/global';
import { ForgetPasswordService } from '../../services/methods/ForgetPasswordService';

const ForgotPassword: React.FC = () => {
  const forgetPasswordService: ForgetPasswordService = new ForgetPasswordService();


  const [resetPassSteps, setResetPassSteps] = useState<1 | 2 | 3>(1)
  const [email, setEmail] = useState('')
  const [userEmail, setUserEmail] = useState('')
  const [token, setToken] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [sendCodeBy, setSendCodeBy] = useState<'email' | 'sms'>('email')
  const [time, setTime] = useState(0)
  const [msgInfo, setMsgInfo] = useState('')

  const inputRef1 = useRef<HTMLInputElement>(null)
  const inputRef2 = useRef<HTMLInputElement>(null)
  const inputRef3 = useRef<HTMLInputElement>(null)
  const inputRef4 = useRef<HTMLInputElement>(null)
  const inputRef5 = useRef<HTMLInputElement>(null)
  const inputRef6 = useRef<HTMLInputElement>(null)

  const history = useHistory()

  async function handleAuthenticateEmail() {//event: FormEvent
    // event.preventDefault()
    const userBase64 = encode(email)

    try {
      setIsLoading(true)
      const { data } = await forgetPasswordService.forgetService(userBase64, sendCodeBy);

      const { status, msg, info } = data
      setMsgInfo(info)
      if (status === 'ok') {
        setUserEmail(email)
        setResetPassSteps(2)
        setTime(0)
        setTime(180)
        toast.success(msg)
      } else {
        toast.error(msg)
      }
    } catch (error: any) {
      if (error.response) {
        toast.error(error.response.data.errorMessage)
      }
      console.log(error)
    } finally {
      setIsLoading(false)
    }

  }

  async function handleAuthenticateCode() {//event: FormEvent
    // event.preventDefault()
    const userBase64 = encode(userEmail)
    const codeValue = `${inputRef1.current?.value}${inputRef2.current?.value}${inputRef3.current?.value}${inputRef4.current?.value}${inputRef5.current?.value}${inputRef6.current?.value}
    `;
    setIsLoading(true)
    try {
      const { data } = await forgetPasswordService.codeValidate(userBase64, codeValue);

      const { status, msg, token } = data

      if (status === 'ok') {
        setToken(token)
        toast.success(msg)
        setResetPassSteps(3)
      } else {
        toast.error(msg)
        // inputRef1.current.value = ''
        // inputRef2.current?.value = ''
        // inputRef3.current?.value = ''
        // inputRef4.current?.value = ''
        // inputRef5.current?.value = ''
        // inputRef6.current?.value = ''
      }
    } catch (error: any) {
      if (error.response) {
        toast.error(error.response.data.errorMessage)
      }
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  async function handleSavePassword(event: FormEvent) {
    event.preventDefault()

    try {
      if (newPassword === confirmPassword) {
        const objectParams = {
          token,
          password: encode(confirmPassword)
        }

        // `{"token":"${token}","password":"${encode(confirmPassword)}"}`
        setIsLoading(true)

        const { data } = await forgetPasswordService.newPassword(objectParams);

        if (data.status === 'ok') {
          toast.success(data.msg)
          history.push('/login')
          setResetPassSteps(1)
        } else {
          toast.error(data.msg)
        }
      } else {
        toast.error('As senhas não correspondem')
      }
    } catch (error: any) {
      if (error.response) {
        toast.error(error.response.data.errorMessage)
      }
      console.log(error)
    } finally {
      setIsLoading(false)
    }

  }

  useEffect(() => {
    time > 0 && setTimeout(() => setTime(time - 1), 1000);
  }, [time])

  return (
    <Container>
      <Modal>
        {
          resetPassSteps === 1
            ? (
              <LinkForgotPass to="/login">
                <FaChevronLeft
                  style={{
                    position: 'absolute',
                    top: '20px',
                    left: '20px',
                    cursor: 'pointer'
                  }}
                  size={20}
                  color={styleSheet.colorMain}
                />
              </LinkForgotPass>
            )
            : (
              <FaChevronLeft
                style={{
                  position: 'absolute',
                  top: '20px',
                  left: '20px',
                  cursor: 'pointer'
                }}
                size={20}
                color={styleSheet.colorMain}
                onClick={() => {
                  setTime(0)
                  if (resetPassSteps === 2) {
                    setResetPassSteps(1)
                  } else {
                    setResetPassSteps(2)
                  }
                }}
              />
            )
        }
        <MainLogo src={logoEthosx} alt="Logo EthosX" />

        {
          resetPassSteps === 1 && (
            <FormContainer onSubmit={(e) => {
              e.preventDefault()
              handleAuthenticateEmail()
            }
            }>
              <InputBlock>
                <FormLabel htmlFor="">Email</FormLabel>
                <InputLogin type="text" value={email} onChange={e => setEmail(e.target.value)} />
              </InputBlock>

              <ContainerForget>
                <FormLabel htmlFor="">Escolha a forma como deseja receber o codigo</FormLabel>
              </ContainerForget>

              <ButtonLogin
                disabled={isLoading}
                type="submit"
                onClick={() => setSendCodeBy('email')}
                isLoading={isLoading}
              >
                Enviar Para Email
              </ButtonLogin>
              <ButtonLogin
                disabled={isLoading}
                type="submit"
                onClick={() => setSendCodeBy('sms')}
                isLoading={isLoading}
              >
                Enviar Para Celular
              </ButtonLogin>
            </FormContainer>
          )
        }

        {
          resetPassSteps === 2 && (
            <FormContainer onSubmit={handleAuthenticateCode}>
              <MessageInfo>{msgInfo}</MessageInfo>
              <InputBlock>
                <FormLabel htmlFor="">Codigo</FormLabel>
                {/* <InputLogin type="text" value={codeValue} onChange={(e) => setCodeValue(e.target.value)} /> */}
                <CodeContainer>
                  <InputCode ref={inputRef1} type="text" name="code-1" onChange={() => inputRef1.current?.value === '' ? inputRef1.current?.focus() : inputRef2.current?.focus()} />
                  <InputCode ref={inputRef2} type="text" name="code-2" onChange={() => inputRef2.current?.value === '' && inputRef3.current?.value === '' ? inputRef1.current?.focus() : inputRef3.current?.focus()} />
                  <InputCode ref={inputRef3} type="text" name="code-3" onChange={() => inputRef3.current?.value === '' && inputRef4.current?.value === '' ? inputRef2.current?.focus() : inputRef4.current?.focus()} />
                  <InputCode ref={inputRef4} type="text" name="code-4" onChange={() => inputRef4.current?.value === '' && inputRef5.current?.value === '' ? inputRef3.current?.focus() : inputRef5.current?.focus()} />
                  <InputCode ref={inputRef5} type="text" name="code-5" onChange={() => inputRef5.current?.value === '' && inputRef6.current?.value === '' ? inputRef4.current?.focus() : inputRef6.current?.focus()} />
                  <InputCode ref={inputRef6} type="text" name="code-6" onChange={() => inputRef6.current?.value === '' ? inputRef5.current?.focus() : handleAuthenticateCode()} />
                </CodeContainer>
                {time > 0 ? (
                  <ResendCodeText>Renviar o codigo disponível em <ResendCodeLink>{time}</ResendCodeLink></ResendCodeText>

                ) : (
                  <ResendCodeText>Não chego o codigo <ResendCodeLink onClick={() => handleAuthenticateEmail()}>clique aqui</ResendCodeLink> para reenviar-lo</ResendCodeText>

                )}
              </InputBlock>


              {/* <ButtonLogin
                isLoading={isLoading}
                disabled={isLoading}
                type="submit"
              >
                Resetar senha
              </ButtonLogin> */}

            </FormContainer>
          )
        }

        {
          resetPassSteps === 3 && (
            <FormContainer onSubmit={handleSavePassword}>
              <InputBlock>
                <FormLabel htmlFor="">Nova Senha</FormLabel>
                <InputLogin type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} />
              </InputBlock>

              <InputBlock>
                <FormLabel htmlFor="">Confirmar senha</FormLabel>
                <InputLogin type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
              </InputBlock>

              <ButtonLogin
                isLoading={isLoading}
                disabled={isLoading}
                type="submit"
              >
                Salvar
              </ButtonLogin>
            </FormContainer>
          )
        }
      </Modal>
    </Container>
  );
}

export default ForgotPassword;